import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Card from '@material-ui/core/Card';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment-timezone';

const marginBottom = { marginBottom: '30px', marginTop: '0px' };

const useStyles = makeStyles({
  root: {
    minWidth: 275,
    borderRadius: 8,
    boxShadow:
      '0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)',
    background: '#fff',
    padding: 0,
    marginTop: 32,
    maxWidth: 600,
  },
  header: {
    fontWeight: 600,
    fontSize: 18,
    padding: '20px 24px 12px 24px',
    borderBottom: '1px solid #E0E0E0',
    background: '#fff',
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    padding: '24px',
    background: '#fff',
  },
  label: {
    flex: 1,
    color: '#757575',
    fontSize: 15,
    marginRight: 24,
    minWidth: 200,
    lineHeight: 1.5,
  },
  value: {
    flex: 2,
    color: '#212121',
    fontSize: 15,
    lineHeight: 1.5,
  },
});

const WelcomeCounsellors = props => {
  const { appointment } = props;
  let clientName = '';
  const classes = useStyles();

  if (appointment) {
    clientName = get(appointment, 'client.preferred_name_with_last_name');

    if (
      appointment.provider_type === 'couples' &&
      appointment.couples_appointment_detail &&
      appointment.couples_appointment_detail.guest
    ) {
      clientName = `${clientName} and ${appointment.couples_appointment_detail.guest.full_name}`;
    }
  }
  return (
    <div>
      <h2 style={marginBottom}>
        <FormattedMessage defaultMessage="Welcome to the waiting room" />
      </h2>
      <h3 style={{ ...marginBottom, fontSize: '20px' }}>
        <FormattedMessage
          defaultMessage="Your session will begin shortly, with {name}"
          values={{ name: <b>{clientName}</b> }}
        />
      </h3>
      {appointment && appointment.provider_type === 'generic' ? (
        <p>
          <FormattedMessage defaultMessage="Please prepare any notes you may have" />
        </p>
      ) : (
        <p>
          <FormattedMessage defaultMessage="Please prepare any notes you may have, they are currently answering assessment questions." />
        </p>
      )}
      <hr style={{ margin: '0', marginBottom: '24px' }} className="line" />
      <Box>
        <Card className={classes.root} variant="outlined">
          <div className={classes.header}>
            <FormattedMessage defaultMessage="Appointment details" />
          </div>
          <Divider />
          <div className={classes.content}>
            <div className={classes.label}>
              {clientName && (
                <FormattedMessage
                  defaultMessage="
              Your client, {clientName}, has included the following appointment details for their session on {appointmentDate}"
                  values={{
                    clientName,
                    appointmentDate: moment(appointment?.start_date).format(
                      'llll',
                    ),
                  }}
                />
              )}
            </div>
            <div className={classes.value}>
              {appointment && appointment.description ? (
                <p>{appointment.description}</p>
              ) : (
                <FormattedMessage defaultMessage="No additional details provided by the client." />
              )}
            </div>
          </div>
        </Card>
      </Box>
    </div>
  );
};

WelcomeCounsellors.propTypes = {
  appointment: PropTypes.object,
};

WelcomeCounsellors.defaultProps = {
  appointment: null,
};

export default WelcomeCounsellors;
